import { Injectable } from '@angular/core';
import { DashboardWidget } from '@parashift/shared/models';
import { DashboardWidgetType } from '@parashift/shared/types';
import { ServiceDecorator } from './decorators';
import { BaseApiService } from './base';
import { Endpoint } from '../env.service';

/**
 * CRUD for individual dashboard widgets (id-api `/v1/dashboard_widgets`). Widgets are
 * normally read sideloaded via the template's `?include=dashboard_widgets`; this service
 * is for the admin management UI, which creates, updates and deletes them individually.
 */
@Injectable({
  providedIn: 'root'
})
@ServiceDecorator({
  model: () => DashboardWidget,
  endpointUrl: DashboardWidgetType
})
export class DashboardWidgetApiService extends BaseApiService<DashboardWidget> {
  className = DashboardWidgetApiService;

  constructor() {
    super();
    this.baseUrl = Endpoint.id;
    this.apiVersion = this.environment.endpoints.version;
  }
}
